const cpfCnpjMixin = {
    data() {
        return {
            cpfCnpj: "",
        }
    },
    methods: {
        ajustaCpf() {
            let cpf = this.cpfCnpj;
            cpf = cpf.replace(/\D/g, "");

            if (cpf.length < 11) {
                this.cpfCnpj = ""
                return
            }

            cpf = cpf.padStart(11, '0');
            cpf = cpf.replace(/\D/g, '')
                .replace(/(\d{3})(\d)/, '$1.$2')
                .replace(/(\d{3})(\d)/, '$1.$2')
                .replace(/(\d{3})(\d)/, '$1-$2')
                .replace(/(-\d{2})\d+?$/, '$1')
            this.cpfCnpj = cpf;
        },
        ajustaCnpj() {
            let cnpj = this.cpfCnpj;
            cnpj = cnpj.replace(/\D/g, "");

            if (cnpj.length < 14) {
                this.cpfCnpj = ""
                return
            }

            cnpj = cnpj.padStart(14, '0');
            cnpj = cnpj.replace(/\D/g, '')
                .replace(/(\d{2})(\d)/, '$1.$2')
                .replace(/(\d{3})(\d)/, '$1.$2')
                .replace(/(\d{3})(\d)/, '$1/$2')
                .replace(/(\d{4})(\d)/, '$1-$2')
                .replace(/(-\d{2})\d+?$/, '$1');
            this.cpfCnpj = cnpj;
        },
        ajustaCpfCnpj() {
            let cpfCnpj = this.cpfCnpj;

            cpfCnpj = cpfCnpj.replace(/\D/g, "");

            if (cpfCnpj.length === 11)
                this.ajustaCpf();
            else if (cpfCnpj.length === 14)
                this.ajustaCnpj();
            else
                this.cpfCnpj = "";
        }
    }
};

export default cpfCnpjMixin;